import { PlayerProperty, Save, Restore } from '../PlayerProperty';
import IPlayerData from '../../IPlayerData';
import { IPlayerState } from '../../../State/Player/IPlayerState';
import { restoreNumber } from '../../ParseHelper';
import { MathHelper } from '../../../Utility/MathHelper';
import { MAX_WORLDS } from '../../../Constants/World';

type PlayerStateKey = 'maxWorld';
type PlayerDataKeys = 'maxWorld';
export default class MaxWorld implements PlayerProperty<
    PlayerStateKey,
    PlayerDataKeys
> {
    public isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean {
        return playerEndpointData.maxWorld !== playerStateData.maxWorld;
    }

    public restore(playerEndpointData: IPlayerData): Restore<PlayerStateKey> {
        return MathHelper.clamp(
            restoreNumber(playerEndpointData.maxWorld, 1),
            1,
            MAX_WORLDS
        );
    }

    public save(playerStateData: IPlayerState): Save<PlayerDataKeys> {
        return {
            maxWorld: playerStateData.maxWorld,
        };
    }
}
